/* eslint-disable */ 
import Vue from 'vue'
import { LOGIN_URL, SITE_NAME, CHANGE_TELEFONO_URL } from '@/config'
import SessionService from '@/services/SessionService'
import VueRouter from 'vue-router'
import Turnos from '@/views/Turnos.vue'
import store from '@/store'


Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'Turnos disponibles' }
    },
    {
      path: '/turnos',
      name: 'Turnos disponibles',
      component: () =>
        import(/* webpackChunkName: 'turnos' */ '@/views/Turnos.vue'),
    },
    {
      path: '/mis-reservas',
      name: 'Mis Turnos',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: 'dashboard' */ '@/views/Dashboard.vue'),
    },
    {
      path: '/mis-pacientes',
      name: 'Pacientes',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: 'pacientes' */ '@/views/AdministrarPacientes.vue'),
    },
  ]
})

router.beforeEach(async (to, from, next) => {
  // Is logged in?
  if (!SessionService.isLoggedIn()) {
    location.href = `${LOGIN_URL}?nombre=${SITE_NAME}&redirect=${location.origin}${to.path}`
    return
  }

  await store.dispatch('session/restore', null, {root: true})

  if(!store.getters['parametro/getIsTelefonoSet'] && !store.getters['parametro/getRedirectedOnce']){
    await store.dispatch('parametro/setRedirectedOnce')
    location.href = `${CHANGE_TELEFONO_URL}?nombre=${SITE_NAME}&redirect=${location.origin}${to.path}`
    return
  }

  if(!store.getters['parametro/getHasPacientes'] && to.name !== 'Pacientes'){
    next({name: 'Pacientes'})
    return
  }
  next()
})

function sleep(ms){
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default router
